/* eslint react-hooks/exhaustive-deps: "warn" */

import { useInt } from 'hooks/useInt';

import { Faq } from 'ui/atoms/Faq/Faq';
import { DeliveryTable } from 'ui/organisms/DeliveryTable/DeliveryTable';

import { FddHero } from 'landing-pages/financial-due-diligence/sections/FddHero/FddHero';
import { FddChallenges } from 'landing-pages/financial-due-diligence/sections/FddChallenges/FddChallenges';
import { FddPipeline } from 'landing-pages/financial-due-diligence/sections/FddPipeline/FddPipeline';
import { FddServe } from 'landing-pages/financial-due-diligence/sections/FddServe/FddServe';
import { FddTestimonial } from 'landing-pages/financial-due-diligence/sections/FddTestimonial/FddTestimonial';
import { FddMonitoring } from 'landing-pages/financial-due-diligence/sections/FddMonitoring/FddMonitoring';
import { FddFields } from 'landing-pages/financial-due-diligence/sections/FddFields/FddFields';
import { FddFinalCta } from 'landing-pages/financial-due-diligence/sections/FddFinalCta/FddFinalCta';

import styles from './FinancialDueDiligencePage.module.scss';

import { getDeliveryRows, getFaqItems } from './FinancialDueDiligencePage.data';

export const FinancialDueDiligencePage = () => {
  const { t } = useInt();

  return (
    <div className={styles.wrapper}>
      <FddHero />
      <FddChallenges />
      <FddPipeline />
      <FddServe />
      <FddTestimonial />
      <FddMonitoring />
      <FddFields />
      <DeliveryTable
        title={t('Delivered the way your team works.')}
        description={t(
          'Pull one set of accounts, or every set you hold a position against. The underlying filing never changes.',
        )}
        rows={getDeliveryRows(t)}
      />
      <FddFinalCta />
      <Faq
        className={styles.faq}
        title={t('Questions credit and deal teams ask before they trust a number.')}
        data={getFaqItems(t)}
      />
    </div>
  );
};
